import React from 'react';

interface ScaleDocumentIconProps {
  style?: React.CSSProperties;
}

const ScaleDocumentIcon: React.FC<ScaleDocumentIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 100 100" fill="none">
      <title>Document Transcription</title>
      <path
        d="M6.7002 75L50.0002 100L93.3002 75H6.7002ZM93.3002 75L87.0502 68.75L93.3002 62.5V50L87.0502 43.75L93.3002 37.5V25L50.0002 0L29.7202 15.4L6.7002 25V37.5L12.9502 43.75L6.7002 50V62.5L12.9502 68.75L6.7002 75"
        fill="#6A11EA"
      />
      <path
        d="M6.6998 75.001L93.2998 75.001L93.2998 62.501L6.6998 62.501L6.6998 75.001Z"
        fill="#943CFF"
      />
      <path
        d="M6.6998 50.001L93.2998 50.001L93.2998 37.501L6.6998 37.501L6.6998 50.001Z"
        fill="#DD45D3"
      />
      <path
        d="M50.0002 0L6.7002 25H44.0002C47.3102 25 50.0002 22.31 50.0002 19V0Z"
        fill="#FD9D52"
      />
    </svg>
  );
};

export default ScaleDocumentIcon;
